import { render } from "./HouseLight.vue?vue&type=template&id=4e2a8e40&scoped=true"
import script from "./HouseLight.vue?vue&type=script&lang=js"
export * from "./HouseLight.vue?vue&type=script&lang=js"

import "./HouseLight.vue?vue&type=style&index=0&id=4e2a8e40&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2a8e40"]])

export default __exports__